import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Stack, Typography } from '@mui/material';

const AccordionSummaryBlock = props => {
	const { label1, value1, label2, value2, label1bold, label2bold, value1bold, value2bold, sx } = props;
	const labelRow1 = label1.length > 0 ? label1 + ':' : '';
	const labelRow2 = label2.length > 0 ? label2 + ':' : '';

	return (
		<Stack direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={0} sx={sx}>
			<Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={0}>
				<Typography variant="caption" sx={{ fontWeight: label1bold ? '600' : 'inherit' }}>
					{labelRow1}
				</Typography>
				<Typography variant="caption" sx={{ fontWeight: value1bold ? '600' : 'inherit' }}>
					{value1}
				</Typography>
			</Stack>
			<Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={0}>
				<Typography variant="caption" sx={{ fontWeight: label2bold ? '600' : 'inherit' }}>
					{labelRow2}
				</Typography>
				<Typography variant="caption" sx={{ fontWeight: value2bold ? '600' : 'inherit' }}>
					{value2}
				</Typography>
			</Stack>
		</Stack>
	);
};

export default AccordionSummaryBlock;
